import { Component, Input } from '@angular/core'
import { AbstractButtonComponent } from '../abstract-button/abstract-button.component'

@Component({
  selector: 'bdg-icon-button',
  templateUrl: './icon-button.component.html',
})
export class IconButtonComponent extends AbstractButtonComponent {
  constructor() {
    super()
  }

  @Input()
  icon: string

  @Input()
  disabled = false
}
